import type { AriaDatapointType } from "owa-analytics-types";

const ErrorHeadersToCheck = [
    "x-owa-error",
    "x-auth-error",
    "x-redir-error",
    "x-jit-error",
    "x-owaerrormessageid",
];

export function getServerErrorName(datapoint: AriaDatapointType, errorResponse: Response): string | null {
    if (errorResponse?.headers) {
        for (const header of ErrorHeadersToCheck) {
            const errorName = errorResponse.headers.get(header);
            if (errorName) {
                datapoint.addCustomData({ errorHeaderKey: header });
                return errorName;
            }
        }
    }
    
    return null;
}
